import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserDTO } from '@shared/dtos';
import { AuthService } from '@shared/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  public userLoggedIn = false;
  public user: UserDTO;
  
  private subs = new Subscription();
  
  constructor(private authService: AuthService) { }
  
  ngOnInit(): void {
    this.subs.add(
      this.authService.token.subscribe(tokenId => {
        this.userLoggedIn = tokenId !== "";
      })
    );

    this.subs.add(
      this.authService.user.subscribe(user => {
        this.user = user;
      })
    )
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public logout() {
    this.userLoggedIn = !this.userLoggedIn;
    this.authService.logout();
  }
}
